import { render, staticRenderFns } from "./SaveCoin.vue?vue&type=template&id=455a1ab4&"
import script from "./SaveCoin.vue?vue&type=script&lang=js&"
export * from "./SaveCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports